<template>
    <div class="agency-view">
        <div class="agency-view__header">
            <order-progress :step="2"></order-progress>
            <hotel-block-header
            :class="{
                'hotel-block-header--agency': true,
                'hotel-block--loading': hotelLoading
            }"
            :agency="true"
            :hotel="hotel"
            @goback="goBack"
            ></hotel-block-header>
        </div>
        <div class="agency-view__sub-header" v-if="mobileActive">
            <image-modal :images="imageList" @showimage="onOpenImageModal"></image-modal>
            <simple-image-modal v-if="showRoomImagesCode" :images="roomImageList" @close="showRoomImagesCode = false"></simple-image-modal>
            <div class="tab-switcher">
                <div class="tab-switcher__nav">
                    <button class="tab-switcher__nav__item" v-for="(tab, tabKey) in tabList" :key="tabKey" :class="{'current': currentTab == tabKey}" @click="currentTab = tabKey" v-text="tab"></button>
                </div>
        </div>
        </div>
        <div class="agency-view__body">
            <transition-group name="list-transition" :class="{'list-transition--next': tabDirection > 0, 'list-transition--prev': tabDirection < 0}">
            <div class="agency-grid" :class="{'agency-grid--loading': loading}" v-show="currentTab == 0 || !mobileActive" :key="0">
                <div class="msg-block msg-block--error" v-if="!loading && verifiedOfferList.length <= 0">
                    <p><b>{{ translations.no_offers }}</b> <a href="javascript:void(0)" v-text="translations.no_offers_ctr" @click="goBack"></a></p>
                </div>
                <agency-block 
                    v-for="(offer, offerKey) in verifiedOfferList" 
                    :offer="offer" 
                    :key="offerKey" 
                    :availbleRoomImageCodes="availbleRoomImageCodes"
                    @loadingbooking="(loadingStatus) => loadingBookingPage = loadingStatus"
                    @showRoomImages="(code) => showRoomImagesCode = code"
                    :booking-loading="loadingBookingPage"
                ></agency-block>

                <button 
                    v-if="verifiedOfferList.length && hasMoreOffers" 
                    :disabled="loading"
                    class="btn btn--load-more" 
                    :class="{'loading': loading}" 
                    @click="veryfyNextOfferChunk" 
                    v-text="translations.load_more_offers">
                </button>
                
                <transition name="fade-transition">
                    <plane-loading v-if="loading && !verifiedOfferList.length" :text="translations.loading_offers"></plane-loading>
                </transition>
            </div>
            <div class="agency-view__info" v-show="currentTab == 1 || !mobileActive" :class="{'agency-view__info--loading': hotelLoading}" :key="1">
                <image-modal :images="imageList" :videos="hotel.heliVideos" @showimage="onOpenImageModal" v-if="hotel.images && !mobileActive"></image-modal>
                <simple-image-modal v-if="showRoomImagesCode && !mobileActive" :images="roomImageList" @close="showRoomImagesCode = false"></simple-image-modal>
                <div class="info-block info-block__buttons" v-if="hotel.heliVideos || hotel.hasMap">
                    <button href="#" class="btn btn-with-icon" v-if="hotel.hasMap" @click="showMapModal = true">
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 19.86 32" class="btn__icon btn__icon btn__icon--left"><path d="M9.93,6.62a3.31,3.31,0,1,0,3.31,3.31A3.31,3.31,0,0,0,9.93,6.62Zm0,8.83a5.52,5.52,0,1,1,5.52-5.52A5.52,5.52,0,0,1,9.93,15.45ZM9.93,0A9.89,9.89,0,0,0,0,9.85c0,5.73,5.33,8.76,9.39,17.39a.59.59,0,0,0,1.08,0c4.06-8.63,9.39-11.66,9.39-17.39A9.89,9.89,0,0,0,9.93,0Zm8.83,27.59c0,2.43-4,4.41-8.83,4.41S1.1,30,1.1,27.59c0-1.57,1.64-2.95,4.11-3.73.29.48.58.95.85,1.44-1.66.45-2.75,1.18-2.75,2,0,1.37,3,2.48,6.62,2.48s6.62-1.11,6.62-2.48c0-.83-1.09-1.56-2.75-2,.27-.49.56-1,.85-1.44C17.12,24.64,18.76,26,18.76,27.59Z"/></svg>
                        <span class="btn__text" v-text="translations.show_on_map"></span>
                    </button>
                </div>
                <div class="info-block info-block--flex" v-if="hotel.loaded">
                    <div class="info-block__text">
                        <h3 v-text="translations.location"></h3>
                        <p>{{ hotel.location }}, {{ hotel.region }}</p>
                    </div>
                    <div class="info-block__temp" v-if="destination && destination.airTemperature">
                        <span>{{ destination.airTemperature }}&deg;C</span>
                        <img src="./../../img/icons/icon-temp-sun.svg" alt="">
                    </div>
                </div>
                
                <template v-if="hotel.description">
                    <div class="info-block" v-for="(hotelDescription, hoteldescriptionKey) in hotel.description" :key="'hotel_description_' + hoteldescriptionKey">
                        <div class="info-block__text">
                            <h3 v-text="hotelDescription.title.text"></h3>
                            <p v-text="hotelDescription.paragraph.text"></p>
                        </div>
                    </div>
                </template>

                <template v-if="hotel.facts && hotel.facts.length">
                    <div class="info-block"  v-for="(factItem, factItemKey) in factList" :key="factItemKey">
                        <div class="info-block__text">
                            <h3 v-text="factItem.name"></h3>
                            <template v-if="factItem.code !== 'facilities'">
                                <p v-for="(factAtribute, factAtributeKey) in factItem.attributes" :key="factAtributeKey">{{ factAtribute.name }}: {{ factAtribute.value }}</p>
                            </template>
                        </div>
                        <div class="info-block__facilities" v-if="factItem.code === 'facilities'">
                            <span class="info-block__facilities__item" v-for="(factAtribute, factAtributeKey) in factItem.attributes" :key="factAtributeKey" v-text="factAtribute.name"></span>
                        </div>
                    </div>
                </template>

                <div class="info-block">
                    <a class="rejsegarantiordning-btn" href="https://www.skovrejser.dk/rejsegarantiordning" target="_blank">
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 521.39 521.39" class="rejsegarantiordning-btn__icon"><path d="m260.69,346.03c12.22,0,29.41-33.05,31.57-85.33h-63.15c2.16,52.29,19.35,85.33,31.57,85.33Z"/><path d="m165.77,239.36h41.81c1.18-29.06,7.18-57.95,17.6-78.34-32.17,12.88-55.39,42.68-59.41,78.34Z"/><path d="m296.21,161.02c10.42,20.39,16.42,49.29,17.6,78.34h41.81c-4.01-35.66-27.24-65.46-59.41-78.34Z"/><path d="m260.69,154.03c-12.22,0-29.41,33.05-31.57,85.33h63.15c-2.16-52.29-19.35-85.33-31.57-85.33Z"/><path d="m165.77,260.69c4.01,35.66,27.24,65.46,59.41,78.34-10.42-20.39-16.42-49.29-17.6-78.34h-41.81Z"/><path d="m410.03,68.69h-21.33v-22.07c0-26.64-25.12-47.46-52.2-40.62l-227.57,62.93c-22.38,1.29-40.23,19.72-40.23,42.42v362.67c0,23.53,19.14,42.67,42.67,42.67h298.67c23.53,0,42.67-19.14,42.67-42.67V111.36c0-23.53-19.14-42.67-42.67-42.67Zm-68.05-42.07c12.45-3.18,25.39,6.91,25.39,20v22.07h-177.5l152.12-42.07Zm-27.95,426.07h-117.33c-5.9,0-10.67-4.77-10.67-10.67s4.77-10.67,10.67-10.67h117.33c5.9,0,10.67,4.77,10.67,10.67s-4.77,10.67-10.67,10.67Zm42.67-42.66h-202.67c-5.9,0-10.67-4.77-10.67-10.67s4.77-10.67,10.67-10.67h202.67c5.9,0,10.67,4.77,10.67,10.67s-4.77,10.67-10.67,10.67Zm-96-42.68c-64.7,0-117.33-52.64-117.33-117.33s52.64-117.33,117.33-117.33,117.33,52.63,117.33,117.33-52.64,117.33-117.33,117.33Z" /><path d="m296.21,339.04c32.17-12.88,55.39-42.68,59.41-78.34h-41.81c-1.18,29.06-7.18,57.95-17.6,78.34Z"/></svg>
                        <span class="rejsegarantiordning-btn__text">
                            <span>Du er beskyttet af</span>
                            <span>Rejsegarantiordningen</span>
                        </span>
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 27.01 26.01" class="rejsegarantiordning-btn__arrow"><path d="M26.13,10.88l-10-10a3,3,0,1,0-4.25,4.24L16.76,10H3a3,3,0,0,0,0,6H16.76l-4.88,4.88a3,3,0,0,0,4.25,4.25l10-10A3,3,0,0,0,27,13,3,3,0,0,0,26.13,10.88Z"></path></svg>
                    </a>
                </div>
            </div>
            <div class="agency-view__map" v-show="currentTab == 2" :key="2">
                <hotel-map v-if="currentTab == 2" :hotel="hotelData"></hotel-map>
            </div>
            </transition-group>
        </div>
        <modal :title="translations.show_on_map" v-if="!mobileActive && showMapModal" @close="showMapModal = false" :close-on-click="true" :is-open="mapModalIsOpen" class="modal-view--bg">
            <svg slot="icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 19.86 32" class="btn__icon btn__icon btn__icon--left"><path d="M9.93,6.62a3.31,3.31,0,1,0,3.31,3.31A3.31,3.31,0,0,0,9.93,6.62Zm0,8.83a5.52,5.52,0,1,1,5.52-5.52A5.52,5.52,0,0,1,9.93,15.45ZM9.93,0A9.89,9.89,0,0,0,0,9.85c0,5.73,5.33,8.76,9.39,17.39a.59.59,0,0,0,1.08,0c4.06-8.63,9.39-11.66,9.39-17.39A9.89,9.89,0,0,0,9.93,0Zm8.83,27.59c0,2.43-4,4.41-8.83,4.41S1.1,30,1.1,27.59c0-1.57,1.64-2.95,4.11-3.73.29.48.58.95.85,1.44-1.66.45-2.75,1.18-2.75,2,0,1.37,3,2.48,6.62,2.48s6.62-1.11,6.62-2.48c0-.83-1.09-1.56-2.75-2,.27-.49.56-1,.85-1.44C17.12,24.64,18.76,26,18.76,27.59Z"/></svg>
            <hotel-map :hotel="hotelData" class="hotel-map--modal"></hotel-map>
        </modal>
    </div>
</template>

<script type="text/javascript">
    import OrderProgress from '../components/order-progress.vue';
    import ImageModal from '../components/image-rotator-modal.vue';
    import SimpleImageModal from '../components/image-modal.vue';
    import HotelBlockHeader from '../components/hotel-block/hotel-block-header.vue';
    import AgencyBlock from '../components/agency-block.vue';
    import API from '../skovapi.js';
    import HotelMap from '../components/hotel-map.vue';
    import Modal from '../components/modal.vue';
    import PlaneLoading from './../components/plane-loading.vue';
    import _ from 'underscore';
    import { trackEvent } from '../tracker';

    export default {
        data() {
            return {
                verifiedOfferList: [ ],
                hotelData: null,
                loading: false,
                hotelLoading: false,
                destinationLoading: false,
                currentTab: 0,
                translations: APP_CONFIG.TRANSLATION.AGENCY_VIEW,
                deviceWith: 0,
                tabDirection: 0,
                showMapModal: false,
                heliModalIsOpen: false,
                mapModalIsOpen: false,
                loadingBookingPage: false,
                currentCodeIndex: -1,
                stopVerification: false,
                offerChunks: [ ],
                offerChunkKey: -1,
                showRoomImagesCode: null,
                countOptions: {
                    useEasing: false,
                    useGrouping: true,
                    separator: ',',
                    decimal: '.',
                    prefix: '',
                    suffix: ''
                } 
            }
        },
        mounted() {
            this.getOffers();
            this.getHotel();
            this.getDesitination();

            this.$store.commit('filters', { });
            this.$store.commit('selectedBookingOffer', { });
            
            this.deviceWith = window.innerWidth;
            window.addEventListener('resize', () => {
                this.deviceWith = window.innerWidth;
            });
        },
        beforeDestroy() {
            this.stopVerification = true;
        },
        watch: {
            showMapModal() {
                setTimeout(() => {
                    this.mapModalIsOpen = this.showMapModal;
                }, 250);

                if(this.showMapModal) {
                    trackEvent({
                        event: 'CTA Klik - Vis på kort',
                        action: (this.hotelData) ? this.hotelData.name : '',
                        destination: (this.$store) ? this.$store.state.destination : null,
                        'interaction-type': 'noninteraction',
                    })
                }
            },
            currentTab(newState, oldState) {
                if(newState > oldState) {
                    this.tabDirection = 1;
                } else {
                    this.tabDirection  = - 1;
                }

                if(newState == 2) {
                    trackEvent({
                        event: 'CTA Klik - Vis på kort',
                        action: (this.hotelData) ? this.hotelData.name : '',
                        destination: (this.$store) ? this.$store.state.destination : null,
                        'interaction-type': 'noninteraction',
                    }) 
                }
            }
        },
        methods: {
            goBack() {
                let eventData = {
                    event: 'CTA Klik - Tilbageknap',
                    action: (this.hotelData) ? this.hotelData.name : '',
                    destination: (this.$store) ? this.$store.state.destination : null,
                    'interaction-type': 'noninteraction',
                }

                if(!_.isEmpty(this.$store.state.travelQuery)) {
                    trackEvent(eventData);
                    this.$router.back();
                } else if(
                    this.$route.query &&
                    this.$route.query.toDate &&
                    this.$route.query.fromDate &&
                    this.$route.query.departureAirport &&
                    this.$route.query.destinationId
                    ) {
                    this.$router.push({
                        path: '/hotels',
                        query: this.$route.query
                    }, (to) => {
                        trackEvent(Object.assign({}, eventData, {
                            target: to.fullPath
                        }))
                    })
                } else {
                    this.$router.push({
                        path: '/'
                    }, (to) => {
                        trackEvent(Object.assign({}, eventData, {
                            target: to.fullPath
                        }))
                    });
                }
            },
            onOpenImageModal(image) {
                if(image !== null) {
                    trackEvent({
                        event: 'CTA Klik - Hotellets billede',
                        action: (this.hotelData) ? this.hotelData.name : '',
                        destination: (this.$store) ? this.$store.state.destination : null,
                        'interaction-type': 'noninteraction',
                    });
                }
            },
            getDesitination() {
                if(this.destinationLoading)
                    return;
                
                this.destinationLoading = true;
                this.$store.dispatch('getDestination', this.getQuery()).then(() => {
                    this.destinationLoading = false;
                }).catch((error) => {
                    console.error(error);
                    this.destinationLoading = false;
                });
            },
            async getHotel() {
                if(this.hotelLoading)
                    return;

                this.hotelLoading = true;
                return API.getHotel(this.hotelId, {...this.getQuery()}).then((res) => {
                    this.hotelData = res.data;
                    this.hotelLoading = false;
                }).catch((error) => {
                    console.log(error);
                    this.hotelData = false;
                    this.hotelLoading = false;
                });
            },
            getQuery() {
                let query = Object.assign({}, this.$route.query);
                
                if(typeof query.roomTypeCode === 'string') {
                    query.roomTypeCode = [query.roomTypeCode];
                }

                if(typeof query.boardTypeCode === 'string') {
                    query.boardTypeCode = [query.boardTypeCode];
                }

                if(typeof query.roomLocatedCode === 'string') {
                    query.roomLocatedCode = [query.roomLocatedCode];
                }

                if(typeof query.adults === 'string') {
                    query.adults = parseInt(query.adults);
                }

                if(typeof query.childrenCount === 'string') {
                    query.childrenCount = parseInt(query.childrenCount);
                }

                if(typeof query.flexibleStartDays === 'string') {
                    query.flexibleStartDays = parseInt(query.flexibleStartDays);
                }

                if(typeof query.flexibleEndDays === 'string') {
                    query.flexibleEndDays = parseInt(query.flexibleEndDays);
                }

                if(query.children) {
                    query.children = JSON.parse(query.children);
                }

                if(typeof query.tourOperator === 'string') {
                    try {
                        query.tourOperator = JSON.parse(query.tourOperator);
                    } catch(e) {
                        query.tourOperator = null;
                    }
                }

                if(typeof query.keywords === 'string') {
                    try {
                        query.keywords = JSON.parse(query.keywords);
                    } catch(e) {
                        query.keywords = null;
                    }
                }

                return query;
            },
            async getOffers() {
                if(this.loading)
                    return;
            
                console.log('Get offers...');
                let query = Object.assign({}, this.getQuery(), {
                    sortBy: 'price',
                    sortDir: 'up'
                });

                if(typeof query.children !== 'object') {
                    query.children = [query.children];
                }

                if(typeof query.departureAirport == 'string') {
                    query.departureAirport = query.departureAirport.split(',');
                }

                this.loading = true;
                return API.getHotelOffers(this.hotelId, query).then(({data}) => {
                    this.offerChunks = _.chunk(data, 10);
                    return this.veryfyNextOfferChunk();
                }).then(() => {
                    this.loading = false;
                }).catch((error) => {
                    console.error(error);
                    this.loading = false;
                });
            },
            async veryfyNextOfferChunk() {
                let nextChunk = this.offerChunkKey + 1;
                if(this.offerChunks[nextChunk]) {
                    this.loading = true;
                    return this.verifyOfferChunk(this.offerChunks[nextChunk])
                        .then((verifiedOffers) => {
                            let offerChunk = verifiedOffers.filter(({status}) => status == 'OK');
                            this.verifiedOfferList = this.verifiedOfferList.concat(_.sortBy(offerChunk, (offer) => {
                                if(offer.totalPrice && offer.totalPrice.value) {
                                    return offer.totalPrice.value;
                                }

                                return 0;
                            }));
                        })
                        .finally(() => {
                            this.offerChunkKey += 1;
                            this.loading = false;
                        });
                }

                return Promise.resolve();
            },
            async verifyOfferChunk(offerCollection) {
                if(this.loadingBookingPage || this.stopVerification) {
                    return Promise.resolve();
                }

                let query = Object.assign({}, this.getQuery());
                if(typeof query.children !== 'object') {
                    query.children = [query.children];
                }

                return API.verifyHotelOffers(offerCollection.map((offer) => offer.code), query)
                    .then(({data}) => {
                        return data.map((validatedOffer) => {
                            let guid = (validatedOffer && validatedOffer.packageOffer) ? validatedOffer.packageOffer.guid : null;
                            if(!guid) {
                                return null;
                            }

                            let offer = offerCollection.filter(offer => offer.guid == guid);
                            if(offer.length) {
                                let idx = offerCollection.indexOf(offer[0]);
                                if(idx > -1) {
                                    return Object.assign(
                                            {}, 
                                            offer[0],
                                            _.pick(validatedOffer.packageOffer, ['flightOffer', 'personPrice', 'totalPrice', 'totalPriceEuro', 'code', 'guid']),
                                            _.pick(validatedOffer, ['bookingInformation', 'paymentInformation', 'paymentTypes', 'status', 'tourOperatorInformation']),
                                            {
                                                originalTotalPrice: offer[0].totalPrice
                                            }
                                        );
                                }
                            }

                            return null;
                        }).filter((offer) => offer !== null);
                    }).catch((error) => {
                        console.error(error);
                        return offerCollection.map((offer) => {
                            return Object.assign({}, offer, {status: "FAIL"});
                        });
                    });
            }
        },
        computed: {
            hotelId() {
                return this.$route.params.hotelid;
            },
            mobileActive() {
                return (this.deviceWith <= 900);
            },
            tabList() {
                return (this.translations.tabs) ? this.translations.tabs : [ ];
            },
            hotel() {
                if(!this.hotelData) {
                    return { };
                }

                return {
                    id: this.hotelData.id || null,
                    title: this.hotelData.name || '',
                    location: _.propertyOf(this.hotelData)(['location', 'name']) || '',
                    region: _.propertyOf(this.hotelData)(['location','region','name']) || '',
                    rating: this.hotelData.rating || { },
                    stars: this.hotelData.category || 0,
                    img: _.propertyOf(this.hotelData)(['mediaData', 'thumbnail']) || '',
                    images: _.propertyOf(this.hotelData)(['mediaData', 'images']) || [ ],
                    description: _.propertyOf(this.hotelData)(['mediaData', 'description']) || '',
                    facts: this.hotelData.facts || [ ],
                    loaded: true,
                    hasMap: true,
                    heliVideos: (!_.isEmpty(this.hotelData.helicopterVideos)) ? [this.hotelData.helicopterVideos[0]] : [ ]
                }
            },
            factList() {
                if(!this.hotel.facts) {
                    return { };
                }

                return this.hotel.facts.map((factItem) => {
                    return {
                        name: factItem.name,
                        code: factItem.code,
                        attributes: factItem.attributes.map((attribute) => {
                            let isBoolean = (typeof attribute.value === 'boolean');
                            let value = attribute.value;
                            if(isBoolean) {
                                value = (value) ? this.translations.yes : this.translations.no;
                            }

                            if(attribute.unit) {
                                if(attribute.unit === 'm' && parseFloat(value) > 1000) {
                                    value = parseFloat(value) / 1000 + ' km';
                                } else {
                                    value += ' ' + attribute.unit;
                                }
                            }

                            return {
                                name: attribute.name,
                                value: value
                            }
                        })
                    }
                });
            },
            destination() {
                return (!_.isEmpty(this.$store.state.destination)) ? this.$store.state.destination : null;
            },
            hasMoreOffers() {
                let nextChunk = this.offerChunkKey + 1;
                return (this.offerChunks[nextChunk]) ? true : false;
            },
            imageList() {
                const maxImageSize = 1700;
                let images = [ ];
                if(!this.hotelData) {
                    return images;
                }

                if(this.hotelData.imageList && this.hotelData.imageList.length) {
                    images = images.concat(
                        this
                            .hotelData
                            .imageList
                            .filter(({motifTypeCode}) => { //Filter out room pictures and batch room pictures
                                return ['W', 'BD'].indexOf(motifTypeCode) <= -1 ? true : false;
                            })
                            .map(({motifType, sizes}) => {
                                const sizeList = Object.values(sizes);
                                const image = sizeList.reverse().find(({maxWidth}) => maxWidth <= maxImageSize);

                                return {
                                    image: (image) ? image.href : sizeList[sizeList.length - 1].href,
                                    description: motifType
                                }
                            })
                    );

                    if(this.hotelData.roomTypes) {
                        images = images.concat(
                            this.hotelData.roomTypes.map(({name, images, code}) => {
                                return images.map((sizes) => {
                                    const sizeList = Object.values(sizes);
                                    const image = sizeList.reverse().find(({maxWidth}) => maxWidth <= maxImageSize);

                                    return {
                                        image: (image) ? image.href : sizeList[sizeList.length - 1].href,
                                        description: name,
                                        roomCode: code
                                    }
                                })
                            }).flatten()
                        )
                    }

                    return images;
                } else if(!this.hotelData.imageList || !this.hotelData.imageList.length) {
                    return this.hotel.images.map((image) => {
                        return {
                            image,
                            description: null
                        }
                    });
                }
            },
            roomImageList() {
                return (this.showRoomImagesCode) ? this.imageList.filter(({roomCode}) => roomCode === this.showRoomImagesCode) : [ ];
            },
            availbleRoomImageCodes() {
                if (this.hotelData.roomTypes) {
                    let images = this.hotelData.roomTypes.filter(({ images }) => {
                        return (images) ? images.length : false;
                    }).map(({ code }) => code);

                    return [...new Set(images)];
                }

                return [ ];
            }
        },
        components: {
            'order-progress':OrderProgress,
            ImageModal,
            'hotel-block-header':HotelBlockHeader,
            'agency-block':AgencyBlock,
            HotelMap,
            Modal,
            PlaneLoading,
            SimpleImageModal
        }
    }
</script>
